import { FeatureConfig } from '@typesApp/Config'
import { baseConfig_CAFlow } from './baseConfig_CAFlow'
import { baseConfig_VDFlow } from './baseConfig_VDFlow'
import { baseConfig_USFlow } from './baseConfig_USFlow'

/**
 * Brand specific feature configuration. Each brand inherits
 * the base CA, US, or VD flow configuration and may include
 * brand specific values.
 */
const BrandFeatureConfig: Record<string, FeatureConfig> = {
  ebd: {
    ...baseConfig_USFlow,
    disableEyemedPlusLogo: true,
    disableScheduleEyeExamLink: true,
    contactUs: ['phone', 'faq'],
  },
  fde: {
    ...baseConfig_USFlow,
    contactUs: ['phone', 'faq'],
  },
  nua: {
    ...baseConfig_USFlow,
    disableInsuranceToggleMessages: true,
  },
  cle: {
    ...baseConfig_CAFlow,
    contactUs: ['phone', 'email', 'chat'],
  },
  lcr: {
    ...baseConfig_CAFlow,
    clickableTooltip: true,
    disableValidateRxAnimation: true,
    rxhelpGuideOptions: {
      hideContacts: true,
      glassesrx: {
        enableWhatSection: false,
        enablePrismSection: true,
      },
    },
  },
  vde: {
    ...baseConfig_VDFlow,
  },
  // GDO France — VD flow
  gdo: {
    ...baseConfig_VDFlow,
  },
  // GOP France — VD flow
  gop: {
    ...baseConfig_VDFlow,
  },
}

type EnvType = 'DEV' | 'TEST' | 'STAGE' | 'PROD'
type BrandConfig = Record<string, FeatureConfig>

const EnvBrandFeatureConfig: Record<string, BrandConfig> = {
  TEST: {
    ebd: {
      ...BrandFeatureConfig.ebd,
      enableDistributeBenefits: true,
    },
  },
  STAGE: {
    vde: {
      ...BrandFeatureConfig.vde,
      disableStrictSSNValidation: true,
    },
  },
}

export const featureConfig: Record<EnvType, BrandConfig> = {
  DEV: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['DEV'],
  },
  TEST: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['TEST'],
  },
  STAGE: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['STAGE'],
  },
  PROD: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['PROD'],
  },
} as const
